import React, { useEffect, useState } from "react";
import "./home.scss";
import Header from "../_Common/header";
import SectionHead from "../_Common/SectionHead";
import WhatsAppFab from "../_Common/WhatsAppFab";
import useSeo from "../../hooks/useSeo";
import { Col, Container, Image, Modal, Row } from "react-bootstrap";

import sailingIcon from "../../assets/img/home/our-fleet/icons/sailing-boat.png";
import boatIcon from "../../assets/img/home/our-fleet/icons/boat.png";
import starIcon from "../../assets/img/home/our-fleet/icons/star.png";
import lightingIcon from "../../assets/img/home/our-fleet/icons/lighting.png";

import sailBoatsImg from "../../assets/img/home/our-fleet/sail-boats.png";
import sailYachtsImg from "../../assets/img/home/our-fleet/sail-yachts.png";
import motorYachtsImg from "../../assets/img/home/our-fleet/motor-yachts.png";
import speedBoatsImg from "../../assets/img/home/our-fleet/speed-boats.png";

import sunsetCruiseImg from "../../assets/img/home/featured-experiences/sunset-cruise.png";
import speedBoatAdventureImg from "../../assets/img/home/featured-experiences/speed-boat-adventure.png";
import privatePartyYachtImg from "../../assets/img/home/featured-experiences/private-party-yacht.png";
import corporateMeetingsEventsImg from "../../assets/img/home/featured-experiences/corporate-meetings-events.png";
import eventCelebrationsImg from "../../assets/img/home/featured-experiences/event-celebrations.png";
import anniversaryCelebrationsImg from "../../assets/img/home/featured-experiences/anniversary-celebrations.png";

import SunsetCruiseIcon from "../../assets/img/home/featured-experiences/icons/sunset.png";
import speedBoatIcon from "../../assets/img/home/featured-experiences/icons/boat.png";
import privatePartyIcon from "../../assets/img/home/featured-experiences/icons/confetti.png";
import corporateMeetingsIcon from "../../assets/img/home/featured-experiences/icons/discussion.png";
import eventCelebrationsIcon from "../../assets/img/home/featured-experiences/icons/celebration.png";
import anniversaryIcon from "../../assets/img/home/featured-experiences/icons/party-popper.png";
import { Link } from "react-router-dom";

export default function Home() {
    useSeo({
        title: "Yacht Rental in Mumbai at Gateway of India | Ocean Tiger",
        description:
            "Private yacht, sail boat and speed boat rental from Gateway of India, Mumbai. Sunset cruises, birthdays, anniversaries and corporate events with a trained crew.",
        canonical: "https://yachtmumbai.in/",
    });

    // Opening a link like /#experiences directly: the browser's own anchor
    // jump happens before React renders, so scroll once the section exists.
    useEffect(() => {
        const id = window.location.hash.slice(1);
        if (!id) return undefined;
        const timer = setTimeout(() => {
            document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
        }, 300);
        return () => clearTimeout(timer);
    }, []);

    // YATCH DATA
    const yachtData = [
        {
            title_icon: sailingIcon,
            title: "Sail Boats",
            capacity: "Traditional Elegance",
            description: "Experience the timeless charm of traditional sailing. Perfect for intimate gatherings and peaceful cruising along Mumbai's coastline.",
            tags: "6-8 Guests",
            image: sailBoatsImg,
            icon: "ri-group-line"
        },
        {
            title_icon: boatIcon,
            title: "Sail Yachts",
            capacity: "Sophisticated Luxury",
            description: "Elevate your celebration with our spacious luxury sail yachts. Combining traditional sailing with modern amenities for an unforgettable...",
            tags: "15-35 Guests",
            image: sailYachtsImg,
            icon: "ri-group-line"
        },
        {
            title_icon: starIcon,
            title: "Motor Yachts",
            capacity: "15-25 Guests",
            description: "Experience the pinnacle of luxury with our modern motor yachts. State-of-the-art amenities, climate control, and opulent interiors.",
            tags: "15-25 Guests",
            image: motorYachtsImg,
            icon: "ri-group-line"
        },
        {
            title_icon: lightingIcon,
            title: "Speed Boats",
            capacity: "6-12 Guests",
            description: "Feel the adrenaline rush with our high-performance speed boats. Perfect for adventure seekers and quick coastal tours.",
            tags: "6-12 Guests",
            image: speedBoatsImg,
            icon: "ri-group-line"
        }
    ];

    const featuredExperiences = [
        {
            id: "sunset_cruise",
            title_icon: SunsetCruiseIcon,
            title: "Sunset Cruise",
            img: sunsetCruiseImg,
            des: "Watch the sun set over the Arabian Sea from our premium yacht. Includes refreshments and music."
        },
        {
            id: "speed_boat_adventure",
            title_icon: speedBoatIcon,
            title: "Speed Boat Adventure",
            img: speedBoatAdventureImg,
            des: "Experience the thrill of high-speed boating with our state-of-the-art speed boats."
        },
        {
            id: "private_party_yacht",
            title_icon: privatePartyIcon,
            title: "Private Party Yacht",
            img: privatePartyYachtImg,
            des: "Celebrate your special moments with a fully customizable private yacht experience."
        },
        {
            id: "corporate_meetings",
            title_icon: corporateMeetingsIcon,
            title: "Corporate Meetings & Events",
            img: corporateMeetingsEventsImg,
            des: "Host high-end business meetings and corporate events on our luxury yacht with state-of-the-art facilities for 2-100 people."
        },
        {
            id: "event_celebrations",
            title_icon: eventCelebrationsIcon,
            title: "Event Celebrations",
            img: eventCelebrationsImg,
            des: "Make your special events unforgettable with our premium yacht celebration packages. Perfect for birthdays, milestones, and grand celebrations."
        },
        {
            id: "anniversary_celebrations",
            title_icon: anniversaryIcon,
            title: "Anniversary Celebrations",
            img: anniversaryCelebrationsImg,
            des: "Celebrate your love story with a romantic anniversary cruise. Create intimate moments on the serene waters of Mumbai."
        }
    ];

    // HANDLE FEATURE
    const [show, setShow] = useState(false);
    const [eventCelebrationsData, setEventCelebrationsData] = useState(null);
    const handleFeature = (data) => {
        setEventCelebrationsData(data);
        setShow(true);
    };

    // CLOSE MODAL
    const handleClose = () => {
        setShow(false);
        setEventCelebrationsData(null);
    };

    const whatsappLinks = {
        "sunset_cruise": "https://api.whatsapp.com/send/?phone=919920088412&text=Hi! I'd like to enquire about Sunset Cruise.%0APlease share availability, pricing, and package details.&type=phone_number&app_absent=0",

        "speed_boat_adventure": "https://api.whatsapp.com/send/?phone=919920088412&text=Hi! I'd like to enquire about Speed Boat Adventure.%0APlease share availability, pricing, and package details.&type=phone_number&app_absent=0",

        "private_party_yacht": "https://api.whatsapp.com/send/?phone=919920088412&text=Hi! I'd like to enquire about Private Party Yacht.%0APlease share availability, pricing, and package details.&type=phone_number&app_absent=0",

        "corporate_meetings": "https://api.whatsapp.com/send/?phone=919920088412&text=Hi! I'd like to enquire about Corporate Meetings & Events.%0APlease share availability, pricing, and package details.&type=phone_number&app_absent=0",

        "event_celebrations": "https://api.whatsapp.com/send/?phone=919920088412&text=Hi! I'd like to enquire about Event Celebrations.%0APlease share availability, pricing, and package details.&type=phone_number&app_absent=0",

        "anniversary_celebrations": "https://api.whatsapp.com/send/?phone=919920088412&text=Hi! I'd like to enquire about Anniversary Celebrations.%0APlease share availability, pricing, and package details.&type=phone_number&app_absent=0",
    };

    const handleBookNow = (book) => {
        const link = whatsappLinks[book.id];

        if (link) {
            window.open(link, "_blank");   // NEW TAB ✔
        } else {
            console.error("No WhatsApp link found for ID:", book.id);
        }
    }


    return (
        <React.Fragment>
            <Header />

            {/* HOME SECTION  */}
            <section className="home-section" id="home">
                <Container>
                    <div className="home-section-content">
                        <p className="eyebrow" data-aos="fade-up">
                            <span>Gateway of India · Mumbai</span>
                        </p>
                        <h1 data-aos="fade-up" data-aos-delay="80">Luxury Sail &amp; Speed Boat Experiences from Gateway of India</h1>
                        <p className="lead" data-aos="fade-up" data-aos-delay="160">Experience the Arabian Sea like never before. Premium yacht charters, sunset cruises, and unforgettable celebrations on Mumbai's pristine waters.</p>

                        <div className="home-section-content-btn" data-aos="fade-up" data-aos-delay="240">
                            <Link className="btn-paper" to="/full-fleet">
                                <span>Explore the Fleet</span>
                                <i className="ri-arrow-right-line"></i>
                            </Link>
                            <button type="button" className="btn-glass" onClick={() => document.getElementById('experiences')?.scrollIntoView({ behavior: 'smooth' })}>
                                <span>View Experiences</span>
                            </button>
                        </div>
                    </div>
                </Container>

                <div className="scroll-mouse" aria-hidden="true">
                    <div className="mouse">
                        <div className="wheel"></div>
                    </div>
                </div>
            </section>

            {/* FEATURED EXPERIENCE SECTION */}
            <section className="featured-experience-section" id="experiences">
                <Container>
                    <SectionHead
                        index="01"
                        eyebrow="Experiences"
                        title="Featured Experiences"
                        lead="Choose from our curated selection of premium yacht and speed boat experiences"
                    />

                    <Row className="featured-experience-content g-3 g-lg-4">
                        {featuredExperiences.map((item, index) => (
                            <Col key={item.id} xs={12} sm={6} lg={4} data-aos="fade-up" data-aos-delay={(index % 3) * 80}>
                                <button type="button" className="media-card media-card--portrait" onClick={() => handleFeature(item)}>
                                    <span className="media-card-img" style={{ backgroundImage: `url(${item.img})` }}></span>
                                    <span className="media-card-body">
                                        <span className="media-card-meta">{String(index + 1).padStart(2, "0")}</span>
                                        <span className="media-card-title">{item.title}</span>
                                    </span>
                                    <span className="media-card-arrow"><i className="ri-arrow-right-up-line"></i></span>
                                </button>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>

            {/* OUR FLEET SECTION  */}
            <section className="home-fleet-section" id="our_fleet">
                <Container>
                    <SectionHead
                        index="02"
                        eyebrow="Fleet"
                        title="Our Fleet"
                        lead="Choose from our diverse collection of vessels, each designed for unique experiences on Mumbai's beautiful waters"
                    />

                    <Row className="g-3 g-lg-4">
                        {yachtData.map((item, i) => (
                            <Col key={item.title} md={6} data-aos="fade-up" data-aos-delay={(i % 2) * 80}>
                                <Link to="/full-fleet" className="media-card media-card--wide">
                                    <span className="media-card-img" style={{ backgroundImage: `url(${item.image})` }}></span>
                                    <span className="media-card-body">
                                        <span className="media-card-meta">{item.tags.replace("-", "–")}</span>
                                        <span className="media-card-title">{item.title}</span>
                                        <span className="media-card-desc">{item.description}</span>
                                    </span>
                                    <span className="media-card-arrow"><i className="ri-arrow-right-up-line"></i></span>
                                </Link>
                            </Col>
                        ))}
                    </Row>

                    <div className="expert-box" data-aos="fade-up">
                        <div>
                            <h3 className="title">Ready to Set Sail?</h3>
                            <p className="subtitle">
                                Choose your perfect vessel and create unforgettable memories on Mumbai's stunning waters. Expert crew, luxury amenities,
                                and exceptional service await.
                            </p>
                        </div>
                        <Link className="btn-ink" to="/full-fleet">
                            <span>View Full Fleet</span>
                            <i className="ri-arrow-right-line"></i>
                        </Link>
                    </div>
                </Container>
            </section>

            {/* GET IN TOUCH SECTION */}
            <section className="get-in-touch" id="contact">
                <Container>
                    <SectionHead
                        index="03"
                        eyebrow="Contact"
                        title="Get In Touch"
                        lead="Ready to embark on an unforgettable journey? Contact us to book your luxury yacht experience"
                    />

                    <div className="spec-row" data-aos="fade-up">
                        <div className="spec-cell">
                            <span className="spec-label"><i className="ri-map-pin-line"></i>Location</span>
                            <p>Gateway of India,<br />Apollo Bandar, Colaba,<br />Mumbai, Maharashtra 400001</p>
                        </div>
                        <div className="spec-cell">
                            <span className="spec-label"><i className="ri-phone-line"></i>Phone</span>
                            <p><a href="tel:+919920088412">+91 99200 88412</a></p>
                        </div>
                        <div className="spec-cell">
                            <span className="spec-label"><i className="ri-time-line"></i>Operating Hours</span>
                            <p>Monday – Sunday<br />7:00 AM – 10:00 PM<br />24/7 Emergency Support</p>
                        </div>
                    </div>

                    <div className="contact-actions" data-aos="fade-up">
                        <p className="note">We respond to all inquiries at the soonest. For urgent bookings, please call us directly.</p>
                        <div className="contact-actions-btns">
                            <a className="btn-ink" href="tel:+919920088412">
                                <i className="ri-phone-line"></i>
                                <span>Call Us</span>
                            </a>
                            <a className="btn-line" href="https://wa.me/919920088412" target="_blank" rel="noreferrer">
                                <i className="ri-whatsapp-line"></i>
                                <span>WhatsApp</span>
                            </a>
                        </div>
                    </div>
                </Container>
            </section>

            {/* EVENT CELEBRATIONS MODAL */}
            <Modal className="event-celebrations-modal" show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>{eventCelebrationsData?.title || "Event Celebrations"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="event-celebrations-img">
                        {eventCelebrationsData?.img && (
                            <Image src={eventCelebrationsData.img} alt={eventCelebrationsData.title} />
                        )}
                    </div>
                    <p className="event-celebrations-desc">{eventCelebrationsData?.des}</p>

                    <button type="button" className="btn-ink btn-block" onClick={() => handleBookNow(eventCelebrationsData)}>
                        <i className="ri-whatsapp-line"></i>
                        <span>Book Now via WhatsApp</span>
                    </button>
                </Modal.Body>
            </Modal>

            <WhatsAppFab />
        </React.Fragment>
    );
}
